export default {
  gologin ({commit}, show) {
    commit('getUser', show)
  }
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js